import type { PublisherTreeOut } from '@/api/generated/schemas';

export interface PublisherRow {
  /** Path-based so the same imprint under two parents stays unique. */
  key: string;
  id: number;
  name: string;
  isImprint: boolean;
}

export const publisherRows = (
  publishers: PublisherTreeOut[] | undefined
): PublisherRow[] =>
  (publishers ?? []).flatMap((publisher) => [
    {
      key: String(publisher.id),
      id: publisher.id,
      name: publisher.name,
      isImprint: false,
    },
    ...(publisher.imprints ?? []).map((imprint) => ({
      key: `${publisher.id}/${imprint.id}`,
      id: imprint.id,
      name: imprint.name,
      isImprint: true,
    })),
  ]);
